import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Grid,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  getCategoryList,
  createCategory,
  deleteCategory,
  updateCategory,
} from "../../api/asset";
import { handleAxiosError } from "../../config/action-config";
import { categoryTable as tableDef } from "../../config/grid-columns-defs";
import DeleteAlertDialog from "../../component/DeleteAlertDialog";
import UpdateDialog from "../../component/UpdateDialog";
import CreateDialog from "../../component/CreateDialog";
import { showAlert } from "../../actions/alert";
import { Controller, useForm } from "react-hook-form";
import BetterControlledTable from "../../component/BetterControlledTable";

const emptyUpdateData = {
  category: "",
  description: "",
};

const emptyNewCategoryData = {
  category: "",
  description: "",
};

export default function CategoryList() {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();
  const user = useSelector((state) => state.user);
  const dialogAction = useSelector((state) => state.dialog);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  const [updateDialogOpen, setUpdateDialogeOpen] = useState(false);
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(-1);
  const [updateId, setUpdateId] = useState(-1);

  const [updateData, setUpdateData] = useState(emptyUpdateData);
  const [newCategoryData, setNewCategoryData] = useState(emptyNewCategoryData);
  console.log("newCategoryData", newCategoryData);
  const onNewCategorySubmit = (newCategoryData) => {
    createCategory(newCategoryData, user.token)
      .then((res) => {
        dispatch(showAlert(res.data.msg));
        setNewCategoryData(emptyNewCategoryData);
        refreshTable();
        setCreateDialogOpen(false);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
        setCreateDialogOpen(false);
      });
  };

  useEffect(() => {
    if (!dialogAction.type) return;
    switch (dialogAction.type) {
      case "EDIT": {
        setUpdateDialogeOpen(true);
        const up = getUpdatableData(dialogAction.data);
        setUpdateData(up);
        break;
      }
      case "DELETE":
        setDeleteDialogOpen(true);
        break;
      case "VIEW":
        dispatch({ type: "" });
        navigate(`${dialogAction.data.id}`);
        break;
      default:
        break;
    }
  }, [dialogAction]);

  useEffect(() => {
    if (deleteId === -1) return;
    deleteCategory(deleteId, user.token)
      .then((res) => {
        dispatch(showAlert(res.data.msg));
        setDeleteId(-1);
        refreshTable();
        setDeleteDialogOpen(false);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
        setDeleteId(-1);
        setDeleteDialogOpen(false);
      });
  }, [deleteId]);

  useEffect(() => {
    if (updateId === -1) return;
    updateCategory(updateId, updateData, user.token)
      .then((res) => {
        dispatch(showAlert(res.data.msg));
        setUpdateId(-1);
        setUpdateData(emptyUpdateData);
        refreshTable();
        setUpdateDialogeOpen(false);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
        setUpdateId(-1);
        setUpdateDialogeOpen(false);
      });
  }, [updateId]);

  const changeUpdateData = (e) => {
    setUpdateData((prev) => ({ prev, [e.target.name]: e.target.value }));
  };

  useEffect(() => {
    if (!createDialogOpen) {
      setNewCategoryData(emptyNewCategoryData);
    }
  }, [createDialogOpen]);

  const [categoryTableRefreshCount, setCategoryTableRefreshCount] = useState(0);

  async function getCategoryTableData(limit, offset) {
    try {
      const { data } = await getCategoryList(
        { sortBy: "asc", limit, offset },
        user.token
      );
      return {
        rows: data.categories,
        total: data.total,
        error: false,
      };
    } catch (error) {
      handleAxiosError(error, dispatch);
      return { error: true };
    } finally {
      // setLoading(false);
    }
  }

  function refreshTable(e) {
    e?.preventDefault();
    setCategoryTableRefreshCount((prev) => prev + 1);
  }

  return (
    <Box className="pmt-container-box">
      <Box className="pmt-title-box">
        <Box className="typography-title">
          <Typography variant="h1" className="pmt-headings-h1">
            Category
          </Typography>
        </Box>
        <Button
          variant="contained"
          style={{ padding: "5px 7px" }}
          onClick={() => {
            setCreateDialogOpen(true);
          }}
          className="blue-button"
        >
          Add Category
        </Button>
      </Box>
      <br />
      <div className="pmt-controll-table ">
        <BetterControlledTable
          hasActionButtons={false}
          getTableRows={getCategoryTableData}
          columns={tableDef}
          perPage={10}
          refreshCounter={categoryTableRefreshCount}
        />
      </div>

      <DeleteAlertDialog
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        setDeleteId={setDeleteId}
        rowId={dialogAction.data?.id}
      />
      <UpdateDialog
        open={updateDialogOpen}
        setOpen={setUpdateDialogeOpen}
        setUpdateId={setUpdateId}
        rowId={dialogAction.data?.id}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              margin="dense"
              name="category"
              fullWidth
              value={updateData.category}
              onChange={changeUpdateData}
              label="Category"
              type="text"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              margin="dense"
              name="description"
              fullWidth
              value={updateData.description}
              onChange={changeUpdateData}
              label="Description"
              type="text"
              variant="outlined"
            />
          </Grid>
        </Grid>
      </UpdateDialog>
      <CreateDialog
        open={createDialogOpen}
        setOpen={setCreateDialogOpen}
        onSubmit={handleSubmit(onNewCategorySubmit)}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              margin="dense"
              name="category"
              fullWidth
              label="Category"
              variant="outlined"
              inputRef={register({
                required: "Category is required.",
              })}
              required
              error={Boolean(errors.category)}
              helperText={errors.category?.message}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              margin="dense"
              name="description"
              fullWidth
              label="Description"
              type="text"
              variant="outlined"
              inputRef={register({
                required: "Description is required.",
              })}
              required
              error={Boolean(errors.description)}
              helperText={errors.description?.message}
            />
          </Grid>
        </Grid>
      </CreateDialog>
    </Box>
  );
}

function getUpdatableData(data) {
  return {
    category: data.category,
    description: data.description,
  };
}
